import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navi from './pages/Navi';
import Footer from './pages/Footer';
import Home from './pages/Home';
import Kontakt from './pages/Kontakt';
import ONas from './pages/ONas';
import Majatkowe from './pages/ubezpieczenia/Majatkowe';
import DlaLekarzy from './pages/ubezpieczenia/DlaLekarzy';
import ZglosSzkode from './pages/ubezpieczenia/ZglosSzkode';
import NaZycie from './pages/ubezpieczenia/NaZycie';
import Osobowe from './pages/ubezpieczenia/Osobowe';
import PolitykaPrywatnosci from './pages/PP';
import CookieConsent from "react-cookie-consent";
import ScrollToTop from './components/ScrollToTop';
import Komunikacyjne from './pages/ubezpieczenia/Komunikacyjne';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navi />
      <div className="page-container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/o-nas" element={<ONas />} />
          <Route path="/ubezpieczenia/osobowe" element={<Osobowe />} />
          <Route path="/ubezpieczenia/komunikacyjne" element={<Komunikacyjne />} />
          <Route path="/ubezpieczenia/majatkowe" element={<Majatkowe />} />
          <Route path="/ubezpieczenia/dla-lekarzy" element={<DlaLekarzy />} />
          <Route path="/ubezpieczenia/na-zycie" element={<NaZycie />} />
          <Route path="/ubezpieczenia/zglos-szkode" element={<ZglosSzkode />} />
          <Route path="/polityka-prywatnosci" element={<PolitykaPrywatnosci />} />
        </Routes>
      </div>
      <Footer />

      <CookieConsent
        location="bottom"
        buttonText="Akceptuję"
        declineButtonText="Odrzucam"
        enableDeclineButton
        cookieName="zgodaNaCookies"
        style={{ background: "#2B373B", fontSize: "14px" }}
        buttonStyle={{ color: "#4e503b", fontSize: "14px", padding: '8px 15px', borderRadius: '5px' }}
        declineButtonStyle={{ background: "#d9534f", color: "#fff", padding: '8px 15px', borderRadius: '5px' }}
        expires={150}
        overlay={true}
        onAccept={() => {
          console.log("Użytkownik zaakceptował cookies");
        }}
        onDecline={() => {
          console.log("Użytkownik odrzucił cookies");
        }}
      >
        Nasza strona korzysta z plików cookies w celach statystycznych i funkcjonalnych. Więcej informacji w&nbsp;
        <a href="/polityka-prywatnosci" style={{ color: "#ffd700", textDecoration: 'underline' }}>polityce prywatności</a>.
      </CookieConsent>
    </Router>
  );
}

export default App;
